import config from 'config';
import wrapUrlWithServerUrl from '../utils/wrap-url-with-server-url';
import httpTimeout from '../http-timeout';

export const del = <TResponse>(url: string) => {
    return httpTimeout<TResponse>(
        new Request(wrapUrlWithServerUrl(url), {
            ...config.fetch.del,
        }),
    );
};

export default del;
